import React from 'react';
import { Typography } from '../../Typography';
import { Quote } from '../../Quote';
import { Flex, FlexProps } from '../../../wag-react/next-components/Flex';
export type TestimonialProps = FlexProps & {
  text: string;
  name: string;
};
export const Testimonial = ({
  text,
  name,
  ...rest
}: TestimonialProps) => <Flex flexDirection="column" {...rest} data-sentry-element="Flex" data-sentry-component="Testimonial" data-sentry-source-file="Testimonial.tsx">
    <Typography color="white" fontSize={['16px', '24px', '32px']} mb="8px" mt={0} data-sentry-element="Typography" data-sentry-source-file="Testimonial.tsx">
      <Quote data-sentry-element="Quote" data-sentry-source-file="Testimonial.tsx">
        {text}
      </Quote>
    </Typography>
    <Typography color="white" fontSize={['16px', '24px', '32px']} mt={0} data-sentry-element="Typography" data-sentry-source-file="Testimonial.tsx">
      {`- ${name}`}
    </Typography>
  </Flex>;